<div class="card-body mt-0 py-5 px-5">
    <div class="row mb-4">
        <div class="col-lg-1 mb-lg-0 mb-4 form-group">
                <label>Filter by:</label>
                <select class="form-control form-select-sm" [(ngModel)]="filterType" (change)="setFilterType(filterType)">
                    <option value="pet">Pet</option>
                    <option value="client">Client</option>
                </select>
        </div>
        <div *ngIf="filterType === 'client'" class="col-lg-2 form-group mb-lg-0 mb-4">

            <label>Pet:</label>
                <select class="form-control form-select-sm" id="inputGroupSelect02" name="_pet_no"
                    [(ngModel)]="filter_pet_no">
                    <option value="0">All Pets</option>
                    <option [value]="item.pet_no" *ngFor="let item of petService.pets">
                        {{ item.pet_name }}
                    </option>
                </select>

       </div>
        <div class="col form-group mb-lg-0 mb-4">
            <label (click)="samp()">Note Type:</label>
            <select class="form-control form-select-sm" name="_typetxtbox" [(ngModel)]="search_typetxtbox">
            <!-- <option value="" [attr.disabled]="true" [attr.selected]="true">Select type</option>
                        <ng-container *ngFor="let item of catalogService.note_type">
                            <option *ngIf="item.parenttype == 0" [value]="item.notetype">{{item.description}}</option>
                        </ng-container> -->
            <option value="-1">ALL NOTES</option>

            <ng-container *ngFor="let item of catalogService.note_type">
                <optgroup [label]="item.description" *ngIf="item.parenttype == 0">
                    <option [value]="item.notetype">All {{item.description}}</option>

                    <ng-container *ngFor="let item2 of catalogService.note_type">
                        <option *ngIf="item2.parenttype == item.notetype" [value]="item2.notetype">
                            {{item2.description}}</option>
                    </ng-container>

                </optgroup>
            </ng-container>

            </select>
        </div>
        <div class="mb-lg-0 mb-4 form-group"   [class]="filterType === 'pet' ? 'col-lg-4' : 'col-lg-3'">
            <label>Note:</label>
            <input type="text" class="form-control form-control-sm" placeholder="Search Notes" [(ngModel)]="search_wordtxtbox">
            <!-- [disabled]="!(search_typetxtbox !== '' || search_wordtxtbox !== '')" -->

        </div>
        <div class="col mb-lg-0 mb-4 form-group">
            <label>Date From:</label>
            <input type="date" class="form-control form-control-sm" placeholder="Begin" [(ngModel)]="search_begin">

        </div>
        <div class="col mb-lg-0 mb-4 form-group">
            <label>Date To:</label>
            <input type="date" class="form-control form-control-sm" placeholder="End" [(ngModel)]="search_end">
        </div>

    </div>


    <div class="card-footer  d-flex justify-content-between px-0 py-3">
        <div>
            <button type="button" class="btn font-weight-bold btn-sm btn-success mr-2" *ngIf="!create" (click)="create = true"> 
                <i class="fas fa-plus icon-sm"></i> Create Note
            </button>
            <button type="button" class="btn font-weight-bold btn-sm btn-secondary" (click)="labdata()" *ngIf="!create">
                <i class="las la-vial"></i> Lab Data
            </button>
            <button type="button" class="btn font-weight-bold btn-sm btn-danger mr-2" *ngIf="create" (click)="create = false"> 
                <i class="las la-times icon-sm"></i> Close
            </button>
            <div class="btn-group" role="group" *ngIf="create">
                <button id="btnGroupDrop1" type="button" class="btn btn-sm btn-secondary dropdown-toggle mr-2" data-toggle="dropdown">
                    <i class="las la-list-ul "></i> {{soap? 'SOAP':'WRITE'}}
                </button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a class="dropdown-item" (click)="soap = false; selectedNoteTypes = []; ">Write</a>
                    <a class="dropdown-item" (click)="soap = true; selectedNoteTypes = []; ">SOAP</a>
                </div>
            </div>
            
        </div>
        <div class="text-right">
            <button class="btn btn-info font-weight-bold btn-sm mr-2" (click)="search_click()">
                <i class="las la-search"></i> Search
            </button>

            <button *ngIf="petService.pet_notes && petService.pet_notes.length > 0 && !show_all"
                class="btn btn-secondary  font-weight-bold mr-2 btn-sm" (click)="show_all = !show_all; showAll();">
                <i class="las la-plus-square"></i> Show All
            </button>
            <button *ngIf="petService.pet_notes && petService.pet_notes.length > 0 && show_all"
                class="btn btn-secondary  font-weight-bold mr-2 btn-sm" (click)="show_all = !show_all; showAll();">
                <i class="la la-minus-square"></i>Show Less
            </button>

            <div class="dropdown float-right">
                <button class="btn btn-info btn-sm font-weight-bold dropdown-toggle" type="button"
                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="la la-sort-alpha-asc"></i>
                    Sort
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" (click)="order(1)">ASC Date</a>
                    <a class="dropdown-item" (click)="order(2)">DESC Date</a>
                    <a class="dropdown-item" (click)="order(5)">ASC Note Type</a>
                    <a class="dropdown-item" (click)="order(6)">DESC Note Type</a>
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="create">
        <table class="table table-bordered table-sm rounded">
            <tr style="background-color: #f8f9fa;" *ngIf="!soap" >
                <td> 
                    <div class="input-group">
                        <textarea class="form-control" [(ngModel)]="note_write" placeholder="Write note:" rows="1"></textarea>
                        <div class="input-group-append">
                          <button class="btn btn-info" type="button" (click)="openQuickNote(0)">
                            <i class="las la-sticky-note"></i> Quick Note
                          </button>
                        </div>
                    </div>
                </td>
                <td style="width: 20%;">
                    <div class="dropdown w-100">
                        <button class="btn btn-success dropdown-toggle w-100" type="button" id="dropdownMenuButton" data-toggle="dropdown" >
                             Note Type
                        </button>
                        <div class="dropdown-menu scrollable-dropdown" style="max-height: 300px;overflow-y: auto;">
                            <ng-container *ngFor="let item of catalogService.note_type">
                                
                                    <!-- Parent Option -->
                                    <div *ngIf="item.parenttype == 0 && item.allowwrite == 1" class="dropdown-header">
                                        <input type="checkbox" [id]="'child' + item.notetype" (change)="onCheckboxChange($event, item.notetype)" [checked]="isSelected(item.notetype)">&nbsp;
                                        {{ item.description }}
                                    </div>
                                    
                                    <!-- Child Option -->
                                    <ng-container *ngFor="let item2 of catalogService.note_type">
                                        <div *ngIf="item2.parenttype == item.notetype && item2.allowwrite == 1" class="dropdown-item">
                                            <input type="checkbox" [id]="'child' + item2.notetype" (change)="onCheckboxChange($event, item2.notetype)" [checked]="isSelected(item2.notetype)">&nbsp;
                                            <label [for]="'child' + item2.notetype">{{ item2.description }}</label>
                                        </div>
                                    </ng-container>

                            </ng-container>
                        </div>
                    </div>
                </td>
                <td class="text-nowrap" style="width:1%; white-space:nowrap;">
                    <button type="button" class="btn btn-primary" (click)="AddNote()">
                      <i class="fas fa-save"></i> Save Note
                    </button>
                </td>
            </tr>
            <thead style="background-color: #f8f9fa;" *ngIf="soap">
                <tr>
                    <td> 
                        <div class="input-group">
                            <textarea class="form-control" [(ngModel)]="note_soap[0].note" placeholder="Subjective:" rows="2"></textarea>
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" (click)="openQuickNote(1)">
                                <i class="las la-sticky-note"></i>
                              </button>
                            </div>
                        </div>
                    </td> 
                    <td rowspan="5" style="width: 15%;">
                        <div class="dropdown w-100">
                            <button class="btn btn-success dropdown-toggle w-100" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                            Note Type
                            </button>
                            <div class="dropdown-menu scrollable-dropdown" style="max-height: 300px;overflow-y: auto;">
                                <ng-container *ngFor="let item of catalogService.note_type">
                                    
                                        <!-- Parent Option -->
                                        <div *ngIf="item.parenttype == 0" class="dropdown-header">
                                            <input type="checkbox"  [id]="'child' + item.notetype" (change)="onCheckboxChange($event, item.notetype)">&nbsp;
                                            {{ item.description }}
                                        </div>
                                        
                                        <!-- Child Option -->
                                        <ng-container *ngFor="let item2 of catalogService.note_type">
                                            <div *ngIf="item2.parenttype == item.notetype" class="dropdown-item">
                                                <input type="checkbox" [id]="'child' + item2.notetype" (change)="onCheckboxChange($event, item2.notetype)">&nbsp;
                                                <label [for]="'child' + item2.notetype">{{ item2.description }}</label>
                                            </div>
                                        </ng-container>
    
                                </ng-container>
                            </div>
                        </div>
                    </td> 
                    <td rowspan="5" style="width: 15%;">
                        <button type="button" class="btn btn-primary w-100" (click)="AddNote()">
                            <i class="fas fa-plus icon-sm"></i> Add Note
                        </button>
                    </td> 
                </tr>
                <tr>
                    <td> 
                        <div class="input-group">
                            <textarea class="form-control" [(ngModel)]="note_soap[1].note" placeholder="Objective:" rows="2"></textarea>
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" (click)="openQuickNote(2)">
                                <i class="las la-sticky-note"></i>
                              </button>
                            </div>
                        </div>
                    </td>  
                </tr>
                <tr>
                    <td> 
                        <div class="input-group">
                            <textarea class="form-control" [(ngModel)]="note_soap[2].note" placeholder="Assessment:" rows="2"></textarea>
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" type="button" (click)="openQuickNote(3)">
                                <i class="las la-sticky-note"></i>
                              </button>
                            </div>
                        </div>
                    </td>  
                </tr>
                <tr> 
                    <td>
                        <div class="input-group">
                            <textarea class="form-control" [(ngModel)]="note_soap[3].note" placeholder="Plans:" rows="2"></textarea>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" (click)="openQuickNote(4)">
                                    <i class="las la-sticky-note"></i>
                                </button>
                            </div>
                        </div> 
                    </td> 
                </tr> 
                <tr> 
                    <td>
                        <div class="input-group">
                            <textarea class="form-control" [(ngModel)]="note_soap[4].note" placeholder="Progress:" rows="2"></textarea>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" (click)="openQuickNote(5)">
                                    <i class="las la-sticky-note"></i>
                                </button>
                            </div>
                        </div> 
                    </td> 
                </tr> 
            </thead>
        </table> 
    </div>

    <div class="table-responsive max-h-500px" (scroll)="onContainerScroll($event)">
        <table class="table table-bordered table-sm rounded">
 
            <thead class="thead-light">
                <tr>
                    <th *ngIf="filterType === 'client'">Pet</th>
                    <th>Note</th>
                    <th>
                        Date
                        <i *ngIf="petService.notes_order === 1" class="fas fa-sort-amount-down-alt icon-sm"></i>
                        <i *ngIf="petService.notes_order === 2" class="fas fa-sort-amount-down icon-sm"></i>
                    </th>
                    <th class="text-center min-w-100px">Actions</th>
                </tr>
            </thead>
            <tbody> 
                <tr *ngIf="DisplayedNotes.length === 0 && !isLoading">
                    <td colspan="4">
                        No information available
                    </td>
                </tr>
                <tr *ngFor="let item of DisplayedNotes">
                    <!--td>
                        <span class="text-dark font-weight-bolder text-hover-primary mb-1"
                            (click)="edit(item)"> {{ item.type_desc }}</span>
                        <p *ngIf="client_no > 0">{{ item.pet_name }}</p>
                    </td!-->
                    <td *ngIf="filterType === 'client'">{{ item.pet_name }}</td>
                    <td> 
                        <p style="font-size:smaller; color: blue; margin-bottom: 2px;">{{getNoteTypesText(item.notetype_list)}}</p>

                        <!-- Check for note type 40 (Image) -->
                        <ng-container *ngIf="item.notetype_list == 40; else checkNoteType41">
                            <button type="button" class="btn btn-secondary btn-xs" (click)="getImage(parseNote(item.notetext).imageId)">
                                <i class="las la-image"></i>
                            </button>
                            {{ parseNote(item.notetext).text }}
                        </ng-container>

                        <!-- Check for note type 41 (PDF Document) -->
                        <ng-template #checkNoteType41>
                            <ng-container *ngIf="item.notetype_list == 41; else checkNoteType43">
                                <button type="button" class="btn btn-success btn-xs" (click)="getDocument(parseNote(item.notetext).fileId)">
                                    <i class="las la-file-pdf"></i>
                                </button>
                                {{ parseNote(item.notetext).text }}
                            </ng-container>
                        </ng-template>

                        <!-- Check for note type 43 (Lab Test) -->
                        <ng-template #checkNoteType43>
                            <ng-container *ngIf="item.notetype_list == 43; else otherNoteType">
                                <button type="button" class="btn btn-info btn-xs" (click)="getLabTest(item.notetext)">
                                    <i class="las la-table"></i> Lab Test Table
                                </button> Click to Open
                                <!-- {{ parseNote(item.notetext).text }} -->
                            </ng-container>
                        </ng-template>
                    
                        <!-- For plain text notes -->
                        <ng-template #otherNoteType>
                            <span *ngIf="!item.show_more && rows(item.notetext) > 3"
                                (click)="item.show_more = !item.show_more">
                                <i class="la la-plus-square"></i> Show more
                            </span>
                            <span *ngIf="item.show_more && rows(item.notetext) > 3"
                                (click)="item.show_more = !item.show_more">
                                <i class="la la-minus-square"></i> Show less
                            </span>
                            <div class="form-control py-0 px-0 border-0" *ngIf="rows(item.notetext) <= 3">
                                <div [innerHTML]="item.notetext | newlineToBr"></div>
                            </div>
                            <textarea class="form-control  py-0 px-0 border-0" rows="3" readonly
                                *ngIf="!item.show_more && rows(item.notetext) > 3"
                                style="overflow: auto; overflow: hidden; resize: none;">{{ item.notetext }}</textarea>
                            <textarea class="form-control py-0 px-0 border-0" readonly
                                *ngIf="item.show_more && rows(item.notetext) > 3" style="resize: none;"
                                rows="14">{{ item.notetext }}</textarea>
                        </ng-template>
                    </td>

                    <td style="white-space: nowrap;">
                        {{ item.notedate }}
                    </td>
                    <td class="text-center min-w-100px d-flex flex-nowrap" >
                        <button type="button" class="btn btn-icon btn-success btn-sm mx-1 my-0" (click)="assign(item)"
                            data-toggle="tooltip" data-placement="top" title="Assign note to a different pet.">
                            <i class="lab la-telegram-plane"></i>
                        </button>  
                        <button type="button" class="btn btn-icon btn-secondary btn-sm mx-1 my-0" (click)="edit(item)"
                            [disabled]="!item.editable" data-toggle="tooltip" data-placement="top"
                            title="Editing is not allowed after 24 hours.">
                            <i class="la la-pen"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-danger btn-sm btn-hover-danger my-0 mx-1"
                            (click)="delete(item)" [disabled]="!item.editable" data-toggle="tooltip"
                            data-placement="top" title="Editing is not allowed after 24 hours.">
                            <i class="la la-trash"></i>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="isLoading">
                    <td colspan="3" class="text-center py-2">
                        <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                        <span class="ml-2 text-primary font-weight-bold" style="font-size: medium !important;">Loading more...</span>
                    </td>
                </tr>
                <tr *ngIf="!isLoading && DisplayedNotes.length > 0 && allDataLoaded">
                    <td colspan="3" class="text-center text-muted py-2">
                        End of results
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
</div>


<!-- New Modal -->
<div class="modal fade" id="modalEditNote" tabindex="-1" role="dialog" aria-labelledby="modalEditNoteLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit Note</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body"> 
                <div class="form-group">
                    <label>Note</label>
                    <textarea class="form-control" rows="15" [(ngModel)]="note_write1" placeholder="Write your document here..."></textarea>
                    <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
                </div>
                <div class="form-group">
                    <div class="dropdown w-100">
                        <button class="btn btn-success dropdown-toggle w-50" type="button" id="dropdownMenuButton" data-toggle="dropdown" [disabled]="editNotetype">
                        Note Type
                        </button>
                        <div class="dropdown-menu scrollable-dropdown" style="max-height: 300px;overflow-y: auto;">
                            <ng-container *ngFor="let item of catalogService.note_type">
                                
                                    <!-- Parent Option -->
                                    <div *ngIf="item.parenttype == 0 && item.allowwrite == 1" class="dropdown-header">
                                        <input type="checkbox" [id]="'child' + item.notetype" (change)="onCheckboxChange($event, item.notetype)">&nbsp;
                                        <b>{{ item.description }}</b>
                                    </div>
                                    
                                    <!-- Child Option -->
                                    <ng-container *ngFor="let item2 of catalogService.note_type">
                                        <div *ngIf="item2.parenttype == item.notetype && item2.allowwrite == 1" class="dropdown-item">
                                            <input 
                                                type="checkbox" 
                                                [id]="'child' + item2.notetype" 
                                                (change)="onCheckboxChange($event, item2.notetype)" 
                                                [checked]="petService.note.notetype_list.includes(item2.notetype)" 
                                            >
                                            &nbsp;
                                            <label [for]="'child' + item2.notetype">{{ item2.description }}</label>
                                        </div>
                                    </ng-container>

                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="saveEdit()">Save Changes</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalQuickNote" tabindex="-1" role="dialog" aria-labelledby="modalQuickNote" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Quick Notes</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <button type="button" class="btn btn-secondary m-2 col-3" *ngFor="let item of quick_notes" (click)="clickQuickNoteBtn(item)">{{item.quick_note_code}}</button>
                <button type="button" class="btn btn-secondary m-2 col-6" (click)="clickQuickDiagnosis()">All Active Diagnosis</button>
            </div> 
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- New Modal -->
<div class="modal fade" id="modalQuickNoteText" tabindex="-1" role="dialog" aria-labelledby="modalWordDocLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalWordDocLabel">Quick Note</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <textarea class="form-control" rows="28" [(ngModel)]="Altered_QuickText" placeholder="Write your document here..."></textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="applyQT()">Apply</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
 

<div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="imageModalLabel">Image Preview</h5>
                <button type="button" class="close" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body "> 

                <div class="card w-100">
                    <img [src]="imageData" class="img-fluid"> 
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Modal for Lab Test Table -->
<div class="modal fade" id="modalLabTestTable" tabindex="-1" role="dialog" aria-labelledby="modalLabTestTableLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalLabTestTableLabel">Lab Test Table</h5> 
                <button type="button" class="close" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                        <thead class="thead-light">
                            <tr>
                                <th style="width: 30%;">Test Name</th>
                                <th style="width: 15%;">Result</th> 
                                <th style="width: 15%;">Range</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let record of labtest_table" [ngClass]="{'font-weight-bolder': isValueOutOfRange(record.labtest_val, record.range)}">
                                <td>{{ record.test_desc }}</td>
                                <td>
                                    {{ record.labtest_val }}
                                    <span style="pointer-events: none;text-decoration: none;font-size: smaller; color: gray;">{{ record.units }}</span>
                                </td>
                                <td>{{ record.range }}</td>
                                <td>{{ record.comment }}</td>
                                <!-- <td>{{ record.date | date:'shortDate' }}</td> -->
                            </tr>
                            <tr *ngIf="labtest_table.length === 0">
                                <td colspan="5" class="text-center">No lab test records available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
 